import OtherProductId from "~/constants/OtherProductId";

// Details of the UiMeet3D packages
// Active single property websites
// Minutes premium videoconferencing
// Notifications
const UiMeet3dPackageInfos = {
  [OtherProductId.UI_MEET_3D_ACTIVE_1]: {
    nameTranslationKey: "billingCentral:uiMeet3dActive1",
    shortNameTranslationKey: "billingCentral:uiMeet3dActive1Short",
    activeTours: 1,
    minutes: 50,
    notifications: 50,
    leads: 50,
    color: "grey",
    colorCode: null,
  },
  [OtherProductId.UI_MEET_3D_ACTIVE_5]: {
    nameTranslationKey: "billingCentral:uiMeet3dActive5",
    shortNameTranslationKey: "billingCentral:uiMeet3dActive5Short",
    activeTours: 5,
    minutes: 100,
    notifications: 100,
    leads: 100,
    color: "green",
    colorCode: null,
  },
  [OtherProductId.UI_MEET_3D_ACTIVE_12]: {
    nameTranslationKey: "billingCentral:uiMeet3dActive12",
    shortNameTranslationKey: "billingCentral:uiMeet3dActive12Short",
    activeTours: 12,
    minutes: 200,
    notifications: 200,
    leads: 200,
    color: "blue",
    colorCode: "#4371c3",
  },
  [OtherProductId.UI_MEET_3D_ACTIVE_50]: {
    nameTranslationKey: "billingCentral:uiMeet3dActive50",
    shortNameTranslationKey: "billingCentral:uiMeet3dActive50Short",
    activeTours: 50,
    minutes: 500,
    notifications: 500,
    leads: 500,
    color: "yellow",
    colorCode: "#ffbf00",
  },
  [OtherProductId.UI_MEET_3D_UNLIMITED]: {
    nameTranslationKey: "billingCentral:uiMeet3dUnlimited",
    shortNameTranslationKey: "billingCentral:uiMeet3dUnlimitedShort",
    activeTours: 1000000,
    minutes: 1000000,
    notifications: 1000000,
    leads: 1000000,
    color: "orange",
    colorCode: "#ec7c30",
  },
};

export default UiMeet3dPackageInfos;
